/**
 * @description The status of eKYC for the customer.
 */
export enum CustomerIdentificationStatusType {
  NotAttempted = 'NotAttempted',
  Verified = 'Verified',
  Fail = 'Fail',
  InProgress = 'InProgress',
  MustUpdate = 'MustUpdate',
  NotRequired = 'NotRequired',
}



// WEBPACK FOOTER //
// ./src/model/types/customer-identification-status-type.ts